export default __webpack_public_path__ + "static/media/cijevizolirana.fc850488.jpg";